import { Injectable } from '@angular/core';
import { User, UserProfile } from '@api/models/user/user';
import { Urls } from '@core/config/urls';
import { LoginUser, OldLegacyBaseApiService, PaginationResult } from '@smartera/core';
import { LegacyBaseApiService } from '@smartera/core';
import { Menu } from '@modules/security/profile/models/menu';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class UserService extends OldLegacyBaseApiService<any> {
	override get apiUrl(): string {
		return `${Urls.BASE_URL}/sec/users`;
	}

	public findPageableObjects(
		pageNumber: number,
		pageInSize: number,
		sort: any,
		searchObject: any
	): Observable<PaginationResult<any>> {
		const url = this.apiUrl + '/page?page=' + pageNumber + '&size=' + pageInSize + '&sort=' + sort;
		return this._restClientService.post(url, JSON.stringify(searchObject)).pipe(catchError(this.handleError));
	}

	public getUserProfiles(userId: string): Observable<any> {
		return this._restClientService.get(this.apiUrl + '/' + userId + '/profiles');
	}
	public getUserById(id): Observable<User> {
		return this._restClientService.get(this.apiUrl + '/' + id);
	}

	public getUserByEmail(email): Observable<User> {
		return this._restClientService.get(`${this.apiUrl}/mail/${email}/`);
	}

	public getAllMenuByUserId(id): Observable<Menu[]> {
		return this._restClientService.get(this.apiUrl + '/' + id + '/menus');
	}

	public getMenuByUserId(id): Observable<Menu[]> {
		return this._restClientService.get(this.apiUrl + '/' + id + '/menus');
	}

	public createUserProfile(userId: string, userProfile: UserProfile): Observable<UserProfile> {
		return this._restClientService.post(this.apiUrl + '/' + userId + '/profiles', JSON.stringify(userProfile));
	}
	public createUserProfiles(userId: string, userProfiles: UserProfile[]): Observable<UserProfile> {
		return this._restClientService.post(this.apiUrl + '/' + userId + '/profiles/list', JSON.stringify(userProfiles));
	}

	public deleteUserProfile(userId: string, profileId: string): Observable<void> {
		return this._restClientService.delete(this.apiUrl + '/' + userId + '/profiles/' + profileId);
	}

	public sendctivationCode(userId: string): Observable<void> {
		return this._restClientService.get(this.apiUrl + '/' + userId + '/activate');
	}

	public unlockPassword(userId: string): Observable<void> {
		return this._restClientService.get(this.apiUrl + '/' + userId + '/unlock');
	}

	public updateUserInfo(user: User | LoginUser): Observable<User> {
		return this._restClientService.put(this.apiUrl + '/' + user.id + '/basic-info', JSON.stringify(user));
	}

	public getUserInfoById(userId: string): Observable<User> {
		return this._restClientService.get(this.apiUrl + '/basic-info-by-id/' + userId);
	}

	public getUserInfo(): Observable<User> {
		return this._restClientService.get(this.apiUrl + '/basic-info');
	}

	public getLoginParameters(): Observable<any> {
		return this._restClientService.get(this.apiUrl + '/login-parameters');
	}

	public isExists(type: 'username' | 'email', value: string): Observable<any> {
		const requestBody = {
			type,
			value,
		};

		return this._restClientService.post(`${this.apiUrl}/isexists`, JSON.stringify(requestBody));
	}

	public isUserValid(userName: string): Observable<any> {
		return this.isExists('username', userName);
	}

	public isEmailValid(email: string): Observable<any> {
		return this.isExists('email', email);
	}

	public deletePhoto(): Observable<any> {
		return this._restClientService.delete(`${this.apiUrl}/photo`, null);
	}

	public uploadPhoto(file: FormData): Observable<any> {
		return this._restClientService.fileUpload(`${this.apiUrl}/photo`, file);
	}
}

@Injectable()
export class UserProfileService extends OldLegacyBaseApiService<any> {
	private USER_API() {
		return Urls.BASE_URL.toString() + '/api/security/users';
	}

	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/api/security/users';
	}

	public getProfilePaginationByUserId(
		id,
		pageNumber: number,
		pageInSize: number,
		sort: any,
		searchObject: User
	): Observable<any> {
		const url =
			this.USER_API + '/' + id + '/profiles/page?page=' + pageNumber + '&size=' + pageInSize + '&sort=' + sort;
		return this._restClientService.post(url, JSON.stringify(searchObject));
	}

	public getAllProfileByUserId(id): Observable<UserProfile[]> {
		return this._restClientService.get(this.USER_API + '/' + id + '/profiles');
	}
}

@Injectable()
export class UserByProfileService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/users';
	}

	public getAllProfileByUserId(id): Observable<UserProfile[]> {
		return this._restClientService.get(this.apiUrl + '/' + id + '/profiles');
	}
}
